export const formatDeviceOS = (osName?: string | null, osVersion?: string | null): string => {
  const name = osName?.trim() ?? '';
  const version = osVersion?.trim() ?? '';
  if (!name) {
    return version;
  }
  if (!version) {
    return name;
  }

  const normalizedName = name.toLowerCase();
  const normalizedVersion = version.toLowerCase();
  if (normalizedVersion === normalizedName || normalizedVersion.startsWith(`${normalizedName} `)) {
    return version;
  }
  if (normalizedName.endsWith(` ${normalizedVersion}`)) {
    return name;
  }
  return `${name} ${version}`;
};

/**
 * The public Device schema currently exposes osVersion but older API payloads
 * can still include osName, either at the top level or under attributes.
 * Read it defensively without widening the generated SDK types.
 */
export const getDeviceOsName = (device: unknown): string | undefined => {
  if (!device || typeof device !== 'object') {
    return undefined;
  }
  const record = device as Record<string, unknown>;
  const direct = record.osName;
  if (typeof direct === 'string' && direct.trim()) {
    return direct;
  }
  const attributes = record.attributes;
  if (attributes && typeof attributes === 'object') {
    const nested = (attributes as Record<string, unknown>).osName;
    if (typeof nested === 'string' && nested.trim()) {
      return nested;
    }
  }
  return undefined;
};
